import styled from 'styled-components';
import Button from 'xpi-black-ui/Base/Button';

const Container = styled.div`
  min-width: 250px;
  margin-top: 1.4rem;
  border-radius: 7px;
  background-color: #2e3136;
`;

export const ActionContainer = styled.div`
  margin: 15px 10px;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: flex-end;
`;

export const ClearFilterButton = styled(Button)`
  position: relative;
  height: 2rem;
`;

export default Container;
